import { render, staticRenderFns } from "./SelectWrap.vue?vue&type=template&id=a939e6a4&scoped=true&"
import script from "./SelectWrap.vue?vue&type=script&lang=js&"
export * from "./SelectWrap.vue?vue&type=script&lang=js&"
import style0 from "./SelectWrap.vue?vue&type=style&index=0&id=a939e6a4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a939e6a4",
  null
  
)

export default component.exports